import './utility';

export default  function initPopups() {
    // var lib = utility();
    lib.each(lib.queryElementsBySelector('.mobile-filters'), function () {
        new ContentPopup({
            holder: this,
            popup: '.filters-popup',
            btnOpen: '.filter-opener',
            btnClose: '.filter-close'
        });
    });
}

// /*
//  * Popups module
//  */
function ContentPopup(opt) {
    this.options = lib.extend({
        holder: null,
        popup: '.popup',
        btnOpen: '.open',
        btnClose: '.close',
        openClass: 'popup-active',
        clickEvent: 'click',
        mode: 'click',
        hideOnClickLink: true,
        hideOnClickOutside: true,
        delay: 50
    }, opt);
    if (this.options.holder) {
        this.holder = this.options.holder;
        this.init();
    }
}
ContentPopup.prototype = {
    init: function () {
        this.findElements();
        this.attachEvents();
    },
    findElements: function () {
        this.popup = lib.queryElementsBySelector(this.options.popup, this.holder);
        this.btnOpen = lib.queryElementsBySelector(this.options.btnOpen, this.holder);
        this.btnClose = lib.queryElementsBySelector(this.options.btnClose, this.holder);
        this.isTouchDevice = /Windows Phone/.test(navigator.userAgent) || ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch;
    },
    attachEvents: function () {
        // handle popup openers
        var self = this;
        this.clickMode = this.isTouchDevice || (self.options.mode === self.options.clickEvent);

        if (this.clickMode) {
            // handle click mode
            lib.each(this.btnOpen, function (index, btnOpen) {
                lib.event.add(btnOpen, self.options.clickEvent, function (e) {
                    if (lib.hasClass(self.holder, self.options.openClass)) {
                        if (self.options.hideOnClickLink) {
                            self.hidePopup();
                        }
                    } else {
                        self.showPopup();
                    }
                    e.preventDefault();
                });
            });

            // prepare outside click handler
            this.outsideClickHandler = lib.bind(this.outsideClickHandler, this);
        } else {
            // handle hover mode
            var timer, delayedFunc = function (func) {
                clearTimeout(timer);
                timer = setTimeout(function () {
                    func.call(self);
                }, self.options.delay);
            };
            lib.each(this.btnOpen, function (index, btnOpen) {
                lib.event.add(btnOpen, 'mouseover', function () {
                    delayedFunc(self.showPopup);
                });
                lib.event.add(btnOpen, 'mouseout', function () {
                    delayedFunc(self.hidePopup);
                });
            });
            lib.each(this.popup, function (index, popup) {
                lib.event.add(popup, 'mouseover', function () {
                    delayedFunc(self.showPopup);
                });
                lib.event.add(popup, 'mouseout', function () {
                    delayedFunc(self.hidePopup);
                });
            });
        }

        // handle close buttons
        lib.each(this.btnClose, function (index, btnClose) {
            lib.event.add(btnClose, self.options.clickEvent, function (e) {
                self.hidePopup();
                e.preventDefault();
            });
        });
    },
    outsideClickHandler: function (e) {
        // hide popup if clicked outside
        var currentNode = (e.changedTouches ? e.changedTouches[0] : e).target,
            foundFlag = false;

        var matchNodes = function (target, list) {
            var result = false;
            lib.each(list, function (index, tmpNode) {
                if (target === tmpNode) {
                    result = true;
                }
            });
            return result;
        };

        while (currentNode.parentNode) {
            foundFlag = matchNodes(currentNode, this.popup);
            foundFlag |= matchNodes(currentNode, this.btnOpen);
            if (foundFlag) {
                return;
            }
            currentNode = currentNode.parentNode;
        }
        this.hidePopup();
    },
    showPopup: function () {
        // reveal popup
        lib.addClass(this.holder, this.options.openClass);
        lib.each(this.popup, function (index, popup) {
            popup.style.display = 'block';
        });

        // outside click handler
        if (this.clickMode && this.options.hideOnClickOutside && !this.outsideHandlerActive) {
            this.outsideHandlerActive = true;
            lib.event.add(document, 'click', this.outsideClickHandler);
            lib.event.add(document, 'touchstart', this.outsideClickHandler);
        }
    },
    hidePopup: function () {
        // hide popup
        lib.removeClass(this.holder, this.options.openClass);
        lib.each(this.popup, function (index, popup) {
            popup.style.display = 'none';
        });

        // outside click handler
        if (this.clickMode && this.options.hideOnClickOutside && this.outsideHandlerActive) {
            this.outsideHandlerActive = false;
            lib.event.remove(document, 'click', this.outsideClickHandler);
            lib.event.remove(document, 'touchstart', this.outsideClickHandler);
        }
    }
};  